import React, { useState, useEffect } from 'react';
import { navItems, companyInfo, images } from '../data/mock';
import { Menu, X, Phone } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'py-2' : 'py-4'}`
      }
      style={{ background: 'transparent' }}>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <nav className={`relative flex items-center justify-between transition-all duration-300 px-4 lg:px-6 ${isScrolled ? 'py-2' : 'py-3 xl:py-4'}`}>
          {/* Mobile/Tablet Background Wrappers (Split) vs Desktop Background (Unified) */}
          <div className={`absolute inset-0 rounded-full transition-all duration-300 hidden lg:block ${isScrolled ? 'bg-[#1E4D2B] shadow-lg' : 'bg-[#1E4D2B]/90 backdrop-blur-sm'}`} />

          {/* Logo */}
          <button
            onClick={() => scrollToSection('home')}
            className={`relative z-10 flex items-center gap-2 hover:opacity-90 transition-opacity flex-shrink-0 lg:p-0 ${
              // Mobile: Dark green pill background
              'bg-[#1E4D2B] p-3 rounded-full lg:bg-transparent'
              }`}>

            <img
              src={images.logo}
              alt="MeisterGrün Logo"
              className="h-[24px] md:h-[28px] lg:h-[50px] xl:h-[63px] w-auto" />

          </button>

          {/* Desktop Navigation */}
          <div className="relative z-10 hidden lg:flex items-center gap-2 xl:gap-4 px-2 xl:px-6 py-3">
            {navItems.map((item) =>
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-white text-base font-medium px-3 py-2 rounded-full hover:bg-white/10 transition-all duration-200">

                {item.label}
              </button>
            )}
          </div>

          {/* CTA Button */}
          <div className="relative z-10 hidden lg:flex items-center gap-4 pr-2 xl:pr-6">
            <a
              href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
              className="flex items-center gap-2 bg-[#FFD700] text-[#1E4D2B] px-4 py-2.5 rounded-full font-semibold text-base hover:bg-[#FFE44D] transition-all duration-200 hover:-translate-y-0.5">

              <Phone className="w-4 h-4" />
              {companyInfo.phone}
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="relative z-10 lg:hidden text-white p-3 bg-[#1E4D2B] rounded-full hover:bg-[#1E4D2B]/90 transition-colors">

            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </nav>

        {/* Mobile Menu */}
        {isMobileMenuOpen &&
          <div className="lg:hidden mt-2 bg-[#1E4D2B] rounded-3xl p-4 shadow-xl">
            {navItems.map((item) =>
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="block w-full text-left text-white py-3 px-4 rounded-xl hover:bg-white/10 transition-colors">

                {item.label}
              </button>
            )}
            <a
              href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
              className="flex items-center justify-center gap-2 mt-4 bg-[#FFD700] text-[#1E4D2B] px-5 py-3 rounded-full font-semibold hover:bg-[#FFE44D] transition-colors">

              <Phone className="w-4 h-4" />
              {companyInfo.phone}
            </a>
          </div>
        }
      </div>
    </header>);

};

export default Header;